import ScrollManager from './utils/scroll-manager';

const AnchorBehavior = {
    init() {
        const $this = this;
        setTimeout(
            function () {
                $this.scrollToUrlAnchor();
            }, 300
        );
    },

    getAnchor() {
        const currentUrl = document.URL;
        const urlParts = currentUrl.split('#');
        return (urlParts.length > 1) ? urlParts[1] : null;
    },

    scrollToUrlAnchor() {
        const anchor = this.getAnchor();
        if (anchor === null || anchor.length === 0) {
            return;
        }
        const elementAnchor = document.querySelector('#' + anchor);
        if (elementAnchor) {
            ScrollManager.scrollTo(elementAnchor);
        }
    },
};

export default AnchorBehavior;
